<div class="container-fluid mt-3">
    <app-speed-dial-fab (clicked)="dispatch($event)" [options]="FabOptions"></app-speed-dial-fab>

    <div class="row justify-content-center p-3">

        <div class="col-12 my-1 border rounded-1 background-light p-3 w-100">
            <div class="row justify-content-center">
                <p class="text-center" *ngIf="model.NombrePhase === 3">Analyse comportant 3 phases </p>
                <p class="text-center" *ngIf="model.NombrePhase === 12">Analyse comportant 12 pots </p>
                <p class="text-center"> ({{ getAnalysisStatusName(model.Status)}})</p>
            </div>
            <div class="row">
                <div class="col-12 col-md-4">
                    <div class="row align-items-center">
                        <div class="col-4 px-1 text-right  label">Code Echantillon</div>
                        <div class="col-8 px-1 text-left ">{{model.SampleCode}}</div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="row align-items-center">
                        <div class="col-4 px-1 text-right  label">Code Station</div>
                        <div class="col-8 px-1 text-left ">{{model.ELIMSData.StationCode}}</div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="row align-items-center">
                        <div class="col-4 px-1 text-right  label">Nom Station</div>
                        <div class="col-8 px-1 text-left ">{{model.ELIMSData.StationName}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!coreData.IsOffline" class="row justify-content-center p-3">
        <div class="col-12 my-1 border rounded-1 background-light w-100">
            <div class="row" *ngIf="model.Type !== EInterventionType.IBMR">
                <mat-form-field class="col">
                    <mat-chip-grid #chipList1>
                        <mat-chip *ngFor="let u of model.SorterList" [selectable]="selectable" removable="true" (removed)="removeSorter(u)" [disabled]="model.Status === AnalyseStatut.Done" style="background-color: darkgray;">
                            {{u.Fullname}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input #trieur Input [placeholder]="getLabelForSorter()"
                               [matChipInputFor]="chipList1"
                               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                               [matAutocomplete]="auto1"
                               [matChipInputAddOnBlur]="addOnBlur">
                    </mat-chip-grid>
                    <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="selectedSorter($event)">
                        <mat-option *ngFor="let u of AllUserList" [value]="u" >
                            {{u.Fullname}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div class="row" *ngIf="model.Type !== EInterventionType.IBMR">
                <mat-form-field class="col">
                    <mat-label>{{getLabelForSortingDate()}}</mat-label>
                    <input matInput [placeholder]="getLabelForSortingDate()" [matDatepicker]="picker1" [(ngModel)]="model.DateTri" (focus)="picker1.open()"
                           [disabled]="model.Status === AnalyseStatut.Done">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col">
                    <mat-label>{{getLabelForSortingDuration()}}</mat-label>
                    <input matInput [placeholder]="getLabelForSortingDuration()" type="number" [(ngModel)]="model.DurationTri" [disabled]="model.Status === AnalyseStatut.Done">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col">
                    <mat-chip-grid #chipList aria-label="Analyste">
                        <mat-chip *ngFor="let u of model.AnalyserList" [selectable]="selectable" removable="true" (removed)="removeAnalyser(u)" [disabled]="model.Status === AnalyseStatut.Done" style="background-color: darkgray;">
                            {{u.Fullname}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input #analyste Input placeholder="Analystes..."
                               [matChipInputFor]="chipList"
                               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                               [matAutocomplete]="auto"
                               [matChipInputAddOnBlur]="addOnBlur">
                    </mat-chip-grid>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedAnalyser($event)">
                        <mat-option *ngFor="let u of AllUserList" [value]="u" >
                            {{u.Fullname}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col">
                    <mat-label>Date d'analyse</mat-label>
                    <input matInput placeholder="Date d'analyse" [matDatepicker]="picker" [(ngModel)]="model.Date" (focus)="picker.open()" [disabled]="model.Status === AnalyseStatut.Done">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col">
                    <mat-label>Durée d'analyse</mat-label>
                    <input matInput placeholder="Durée d'analyse" type="number" [(ngModel)]="model.Duration" [disabled]="model.Status === AnalyseStatut.Done">
                </mat-form-field>
            </div>
        </div>

    </div>
    <div class="row justify-content-center my-3 g-0">
        <!-- <div class="col-12 col-md-4 col-xl-2 my-1" *ngIf="model.Type !== 3">
            <div class="card w-100 py-2" style="height: 16rem;">

                <button appPreventDoubleClick class="m-auto" mat-fab color="primary" (throttledClick)="openTaxonDialog();" [disabled]="model.Status === 3">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div> -->
        <div class="col-12" *ngIf="model.Type === EInterventionType.IBMR">
            <div class="border rounded-1 background-light p-3">
                <!-- <h5 class="card-header">Végétation Aquatique</h5> -->
                <div class="row">
                    <h5 class="col text-center fw-bold"> Végétation Aquatique</h5>
                </div>
                <div class="card-body">

                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Heterotrophes</mat-label>
                                <input matInput placeholder="Heterotrophes" type="number" [ngModel]="computeHeterotrophes()">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Algues</mat-label>
                                <input matInput placeholder="Algues" type="number" [ngModel]="computeAlgues()">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Bryophytes</mat-label>
                                <input matInput placeholder="Bryophytes" type="number" [ngModel]="computeBryophytes()">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Pteridophytes</mat-label>
                                <input matInput placeholder="Pteridophytes" type="number" [ngModel]="computePteridophytes()">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field class="w-100">
                                <mat-label>Phanerogames</mat-label>
                                <input matInput placeholder="Phanerogames" type="number" [ngModel]="computePhanerogames()">
                            </mat-form-field>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-md-4 col-xl-3 my-3" *ngFor="let t of model.MergedTaxonList">
            <div class="h-100 m-1">
                <div class="border rounded-1 background-light p-3 w-100 d-flex flex-column" style="min-height: 16rem;">

                    <div class="row">
                        <!-- <h5 class="col text-center fw-bold"> Végétation Aquatique</h5> -->
                        <h3 *ngIf="model.Type !== EInterventionType.IBMR" class="text-center" [matTooltip]="t.Comment" [matTooltipDisabled]="t.Comment !== undefined && t.Comment !== ''">SANDRE
                            {{t.SandreCode}}</h3>
                        <h3 *ngIf="model.Type === EInterventionType.IBMR" class="text-center" [matTooltip]="t.Comment" [matTooltipDisabled]="t.Comment !== undefined && t.Comment !== ''">
                            {{t.CodeIBMR}}
                        </h3>
                    </div>

                    <!-- <div class="card-body p-2"> -->
                    <div class="text-center"> {{t.NomOrdre}}</div>
                    <div class="text-center"> {{t.NomFamille}}</div>
                    <div class="text-center"> {{t.NomGenre}}</div>
                    <div class="text-center fst-italic"> {{t.Comment}}</div>

                    <div *ngIf="model.Type === EInterventionType.IBD || model.Type === EInterventionType.IBGN">
                        <div class=" text-center fw-bold"> Quantité: {{t.Quantite}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="row " *ngIf="model.Type === EInterventionType.IBMR">

                        <!-- UR1 -->
                        <div class="col-12 text-center fw-bold"> {{getIBMRPhaseName(1)}}</div>
                        <span *ngIf="t.Quantite1" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(1)}}: {{t.Quantite1}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1, 1)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <!-- <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="openTaxonDialog( 1, 1)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>edit</mat-icon>
                            </button> -->
                            <button *ngIf="t.Comment1" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment1)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>

                        <span *ngIf="t.Quantite2" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(2)}}: {{t.Quantite2}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1, 2)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <!-- <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="openTaxonDialog( 1, 2)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>edit</mat-icon>
                            </button> -->
                            <button *ngIf="t.Comment2" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment2)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>

                        <span *ngIf="t.Quantite3" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(3)}}: {{t.Quantite3}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1, 3)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <!-- <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="openTaxonDialog( 1, 3)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>edit</mat-icon>
                            </button> -->
                            <button *ngIf="t.Comment3" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment3)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>

                        <span *ngIf="t.Quantite4" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(4)}}: {{t.Quantite4}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1, 4)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment4" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment4)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite5" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(5)}}: {{t.Quantite5}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1, 5)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment5" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment5)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite6" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(6)}}: {{t.Quantite6}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1, 6)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment6" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment6)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite7" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(7)}}: {{t.Quantite7}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1, 7)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment7" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment7)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite8" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(8)}}: {{t.Quantite8}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1, 8)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment8" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment8)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite9" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(9)}}: {{t.Quantite9}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1, 9)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment9" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment9)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite10" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(10)}}: {{t.Quantite10}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1, 10)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment10" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment10)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>

                        <!-- UR2 -->
                        <div class="text-center fw-bold"> {{getIBMRPhaseName(2)}}</div>
                        <span *ngIf="t.Quantite11" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(11)}}: {{t.Quantite11}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2, 11)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment11" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment11)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>

                        <span *ngIf="t.Quantite12" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(12)}}: {{t.Quantite12}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2, 12)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment12" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment12)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite13" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(13)}}: {{t.Quantite13}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2, 13)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment13" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment13)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>

                        <span *ngIf="t.Quantite14" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(14)}}: {{t.Quantite14}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2, 14)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment14" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment14)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite15" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(15)}}: {{t.Quantite15}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2, 15)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment15" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment15)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite16" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(16)}}: {{t.Quantite16}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2, 16)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment16" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment16)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite17" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(17)}}: {{t.Quantite17}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2, 17)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment17" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment17)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite18" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(18)}}: {{t.Quantite18}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2, 18)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment18" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment18)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite19" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(19)}}: {{t.Quantite19}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2, 19)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment19" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment19)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                        <span *ngIf="t.Quantite20" class="row justify-content-center align-items-center">
                            <div class="col-auto fw-bold">{{getIBMRTransectName(20)}}: {{t.Quantite20}}</div>
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2, 20)"
                                    [disabled]=" model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button *ngIf="t.Comment20" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="showComment(t.Comment20)">
                                <mat-icon>info</mat-icon>
                            </button>
                        </span>
                    </div>
                    <div *ngIf="model.NombrePhase === 3">
                        <div *ngIf="t.QuantitePhaseA" class=" text-center fw-bold">{{getPhaseName(1)}}: {{t.QuantitePhaseA}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.QuantitePhaseB" class=" text-center fw-bold">{{getPhaseName(2)}}: {{t.QuantitePhaseB}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.QuantitePhaseC" class=" text-center fw-bold">{{getPhaseName(3)}}: {{t.QuantitePhaseC}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 3)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="model.NombrePhase === 12 || model.NombrePhase === 4 || model.NombrePhase === 15" class="row align-items-center">

                        <div *ngIf="t.Quantite1" class="  text-center fw-bold" [class.col-6]="model.NombrePhase === 12 || model.NombrePhase === 15" [class.col-12]="model.NombrePhase === 4">{{getPhaseLabel(model.NombrePhase, 1)}}: {{t.Quantite1}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 1)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>

                        <div *ngIf="t.Quantite2" class="  text-center fw-bold" [class.col-6]="model.NombrePhase === 12 || model.NombrePhase === 15" [class.col-12]="model.NombrePhase === 4">{{getPhaseLabel(model.NombrePhase, 2)}}: {{t.Quantite2}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 2)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite3" class=" text-center fw-bold"[class.col-6]="model.NombrePhase === 12 || model.NombrePhase === 15" [class.col-12]="model.NombrePhase === 4">{{getPhaseLabel(model.NombrePhase, 3)}}: {{t.Quantite3}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 3)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite4" class=" text-center fw-bold"[class.col-6]="model.NombrePhase === 12 || model.NombrePhase === 15" [class.col-12]="model.NombrePhase === 4">{{getPhaseLabel(model.NombrePhase, 4)}}: {{t.Quantite4}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (click)="deletePot(t.SandreCode, 4)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite5" class="col-6  text-center fw-bold">{{getPhaseLabel(model.NombrePhase, 5)}}: {{t.Quantite5}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 5)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite6" class="col-6  text-center fw-bold">{{getPhaseLabel(model.NombrePhase, 6)}}: {{t.Quantite6}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 6)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite7" class="col-6  text-center fw-bold">{{getPhaseLabel(model.NombrePhase, 7)}}: {{t.Quantite7}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 7)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite8" class="col-6  text-center fw-bold">{{getPhaseLabel(model.NombrePhase, 8)}}: {{t.Quantite8}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 8)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite9" class="col-6  text-center fw-bold">{{getPhaseLabel(model.NombrePhase, 9)}}: {{t.Quantite9}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 9)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite10" class="col-6  text-center fw-bold">{{getPhaseLabel(model.NombrePhase, 10)}}: {{t.Quantite10}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 10)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite11" class="col-6  text-center fw-bold">{{getPhaseLabel(model.NombrePhase, 11)}}: {{t.Quantite11}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 11)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite12" class="col-6  text-center fw-bold">{{getPhaseLabel(model.NombrePhase, 12)}}: {{t.Quantite12}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 12)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>

                        <!-- IML -->
                        <div *ngIf="t.Quantite13" class="col-6  text-center fw-bold">{{getPhaseLabel(model.NombrePhase, 13)}}: {{t.Quantite13}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 13)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite14" class="col-6  text-center fw-bold">{{getPhaseLabel(model.NombrePhase, 14)}}: {{t.Quantite14}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 14)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="t.Quantite15" class="col-6  text-center fw-bold">{{getPhaseLabel(model.NombrePhase, 15)}}: {{t.Quantite15}}
                            <button appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="deletePot(t.SandreCode, 15)"
                                    [disabled]="model.Type === EInterventionType.IBD || model.Status === AnalyseStatut.Done">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="model.Type === EInterventionType.IBMR" class="row justify-content-center">
                        <div class="col-12" *ngFor="let d of t.PictureList">
                            {{ d.Name }}
                            <button appPreventDoubleClick class="" mat-icon-button color="primary" (throttledClick)="getDocumentFile(d);">
                                <mat-icon>image</mat-icon>
                            </button>
                            <button appPreventDoubleClick class="" mat-icon-button color="primary" (throttledClick)="deleteDocument(t, d.Code);">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                        <div class="col-auto">

                            <button appPreventDoubleClick mat-icon-button color="accent" (throttledClick)="openMultipleUploadDialog(false, t);">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </div>
                    <!-- </div> -->
                    <div *ngIf="model.Type !== EInterventionType.IBD" class=" p-1 row d-flex justify-content-end mt-auto g-0">
                        <button appPreventDoubleClick class="col-auto" mat-icon-button color="primary" (throttledClick)="openTaxonDialogWithTaxonSelected(t);" [disabled]="model.Status === AnalyseStatut.Done">
                            <mat-icon>edit</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>